<template>
  <div>
    <!-- Topbar -->
    <TestTopbar
      :title="activeExam ? activeExam.shortName : ''"
      :mode="mode"
      @emitClick="showSideBar"
      @submitAnswers="submitAnswers"
    />

    <!-- Sidebar -->
    <TestSidebar
      htmlId="exam-sidebar"
      :exams="exams"
      :activeExamId="activeExamId"
      @changeExam="changeExam"
      :examStatus="examStatus"
    />
    <b-button v-b-toggle.exam-sidebar hidden ref="sideBarToggleBtn">Toggle Sidebar</b-button>

    <ExamineeInstructionsModal
      id="examineInstructionModal"
      :title="activeExam ? activeExam.shortName : null"
      :instructions="activeExam ? activeExam.instruction : null"
      :timeLimitSeconds="activeExam ? activeExam.timeLimitSeconds : null"
      @ok="startExamTimer"
    />
    <ExamTimer ref="examTimer" @timesup="forceProceed"/>
    <ExamAntiCheatModule />

    <b-container class="p-3">
      <!-- Test Instructions -->
      <b-card
        v-if="activeExam && activeExam.instruction"
        header-tag="header"
        footer-tag="footer"
        class="shadow w-md-100 mb-4"
      >
        <template v-slot:header>
          <h6 class="m-0 font-italic text-site-primary">Instructions</h6>
        </template>
        <b-card-text v-html="renderWithImages(activeExam.instruction)"></b-card-text>
        <br>
        <div v-if="minutes" v-html="minutes" />
      </b-card>

      <!-- Questions -->
      <b-card header-tag="header" footer-tag="footer" class="shadow w-md-100">
        <b-card-text v-for="(item, index) in activeExamItems" :key="item.id">
          <ExamItem :index="index + 1" :examItem="item" @saveAnswer="saveAnswer" :questionLayout="activeExam ? activeExam.questionLayout : 'standard'" />
        </b-card-text>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import TestTopbar from "./TestTopbar";
import TestSidebar from "./TestSidebar";
import ExamItem from "./ExamItem";
import ExamineeInstructionsModal from "./ExamineeInstructionsModal";
import ExamTimer from "./ExamTimer"
import ExamAntiCheatModule from "./ExamineeAntiCheatModule"

export default {
  name: "ExamineeTest",
  components: {
    TestTopbar,
    TestSidebar,
    ExamItem,
    ExamineeInstructionsModal,
    ExamTimer,
    ExamAntiCheatModule,
  },
  data() {
    return {
      exams: [],
      mode : null, // focused, null
      activeExamId: null,
      activeExamItems: [],
      activeExamTimer: null,
      hasMadeSubmission: false,
      navigationGuard : true,
      examStatus: {

      },

      examineeAnswers: {},
       // --- Examinee Answers is a hash table
      /*
      {
        examId : {
          itemId : {
            questionNumber : 1
            choice : 1
          }
        }
      } 
       */
    };
  },
  computed: {
    activeExam() {
      const id =
        this.activeExamId && this.exams.length > 0 ? this.activeExamId : 0;
      var activeExam = this.exams.find((exam) => exam.id === id);
      return activeExam;
    },
    minutes() {
      var timeLimitSeconds = this.activeExam ? this.activeExam.timeLimitSeconds : null
      return timeLimitSeconds ? `You have <b>${timeLimitSeconds / 60} minutes</b> to complete this test.` : null
    }
  },
  mounted() {
    this.getAllExamsOfExaminee();
  },
  watch: {
    activeExamId(newValue, oldValue) {
      if (newValue == oldValue || !newValue || newValue == 0) return;

      this.$store
        .dispatch(`examItem/getAllOfExam`, {
          examId: newValue,
        })
        .then((res) => (this.activeExamItems = res.data));
    },
    activeExam(newValue, oldValue){
      if(newValue == oldValue)
        return

      if(newValue.timeLimitSeconds){
        this.$bvModal.show(`examineInstructionModal`)
      }
    }
  },
  methods: {
    getAllExamsOfExaminee() {
      const examineeId = this.$store.getters[`user/roleId`]
      this.$store.dispatch(`exam/getAllOfExaminee`, {examineeId}).then((res) => {
        if (res.data) this.exams = res.data;
        if (!this.activeExamId && this.exams.length > 0) {
          this.activeExamId = this.exams[0].id;
        }
      });
    },
    renderWithImages(text){
      if (text.indexOf(`::img::`) > -1) {
        var textArr = text.split(`::img::`)
        var imageCount = textArr.length
        for(var x = 1; x < imageCount; x++ && x++){
          var metadata = JSON.parse(textArr[x])
          textArr[x] = `<img class="${metadata.class}" id="${metadata.id}" src="${this.$store.getters["examItem/getImage"](metadata.key)}" />`
        }
        text = textArr.join('')
      }

      return text;
    },
    showSideBar() {
      this.$refs.sideBarToggleBtn.click();
    },
    changeExam(examId, dontHideSidebar) {
      this.activeExamId = examId;
      var self = this;
      window.scrollTo(0, 0); 
      if(!dontHideSidebar)
        setTimeout(function () {
          self.$refs.sideBarToggleBtn.click();
        }, 200);
    },
    startExamTimer(){
      this.$refs.examTimer.startTimer(this.activeExam.timeLimitSeconds)
      this.mode = "focused"
    },
    forceProceed(){
      this.submitAnswers(false)
    },
    saveAnswer(examItemId, questionNumber, choiceNumber, choiceText) {
      const examId = this.activeExamId;

      if (!this.examineeAnswers[examId]) this.examineeAnswers[examId] = {};
      this.examineeAnswers[examId][examItemId] = {
        questionNumber, 
        choiceNumber,
        choiceText
      };
    },
    submitAnswers(isFinal) {
      var examineeProfileId = this.$store.getters[`user/roleId`];
      this.$refs.examTimer.clearTimer()
      // --- Send Answers
      return this.$store
        .dispatch("examineeAnswer/saveAnswers", {
          examineeProfileId,
          examineeAnswers: this.examineeAnswers,
        })
        .then(() => {
          // --- Credit Consumption
          var self = this
          if (!this.hasMadeSubmission) {
            return this.$store.dispatch("examinee/consumeCredit", {
              id: this.$store.getters["user/roleId"],
            })
            .then(function(){
              self.hasMadeSubmission = true
            });
          }
        })
        .then(() => {
          if(!isFinal){
            this.mode = null
            this.examStatus[this.activeExamId] = "disabled"
            var currentExamIndex = this.exams.findIndex(exam => exam.id == this.activeExamId)
            if(currentExamIndex >= this.exams.length - 1){
              isFinal = true
            }
            else{
              var nextExamIndex = currentExamIndex+1
              this.changeExam(this.exams[nextExamIndex].id, true)
            }
          }
          
          // Have user proceed to Success Page
          if (isFinal) {
            this.$store.dispatch("examinee/update", {
              id: this.$store.getters["user/roleId"],
              data: { status: "completed" },
            })
            .then(()=>{
              // Router Push
              this.$router.push(`/examinee/result`)
            })
          }
          else{
            // Go to next exam
            
            
            this.$bvModal.hide("submit-modal");
          }
        });
      
    },
  },
};
</script>

<style lang="css" scoped>
.termsAndConditionContainer {
  overflow-y: scroll;
  height: 350px;
}

</style>